import React from "react";
import { Box, Typography, Grid, Tooltip } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useParcels } from "../../../services/clear-customs/overall";
import { formatNumberShort } from "../../../components/formatter";

export const Summary = () => {
  const metrics = ["Parcels Handled", "Parcels Cleared", "Parcels D-Scanned"];
  const { parcelsHandled = [], parcelsCleared = [], dScan = [] } = useParcels();

  const getValue = (data, periodType) => {
    const entry = data?.find?.((item) => item?.type === periodType);
    if (!entry) return "-";

    return (
      entry?.parcelCount ||
      entry?.dScannedParcelsCount ||
      entry?.dscannedParcelsCount ||
      "-"
    );
  };

  const periods = [
    { type: "day" },
    { type: "week" },
    { type: "month" },
    { type: "quarter" }
  ];

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 4px -2px var(--10), 0 4px 6px -1px var(--10)",
        border: "solid 1px var(--new-border)",
        backgroundColor: "var(--app-body)"
      }}
    >
      {/* Header */}
      <Box
        sx={{
          height: "48px",
          flexGrow: 0,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 16px",
          borderBottom: "solid 1px var(--new-border)"
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={600}
          fontSize={"20px"}
          sx={{
            height: "28px",
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "8px",
            padding: 0,
            color: "var(--font-strong-default)"
          }}
        >
          <FormattedMessage id="summary" defaultMessage="Summary" />
        </Typography>
      </Box>

      <Grid container sx={{ padding: "16px" }}>
        {periods.map((period, colIndex) => (
          <Grid item xs={3} key={colIndex}>
            {metrics.map((metric, rowIndex) => {
              let value = "-";

              if (metric === "Parcels Handled") {
                value = getValue(parcelsHandled, period.type);
              } else if (metric === "Parcels Cleared") {
                value = getValue(parcelsCleared, period.type);
              } else if (metric === "Parcels D-Scanned") {
                value = getValue(dScan, period.type);
              }

              return (
                <Box
                  key={rowIndex}
                  sx={{
                    height: "90px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "end",
                    borderBottom:
                      rowIndex < metrics.length - 1
                        ? "2px solid #e8ebef"
                        : "none"
                  }}
                >
                  {colIndex === 0 && (
                    <Typography
                      variant="body1"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        paddingLeft: "15px",
                        fontSize: "20px",
                        fontWeight: 600,
                        color: "var(--font-strong-default)"
                      }}
                    >
                      <Box sx={{ width: "8px", height: "8px", flexGrow: 0, borderRadius: "50%", backgroundColor: "var(--font-strong-default)" }} />
                    {metric}
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontSize: "28px",
                      fontWeight: 700,
                      color: "var(--font-strong-default)"
                    }}
                  >
                    <Tooltip
                      placement="top"
                      title={value?.toLocaleString?.("de-DE") || 0}>
                      {formatNumberShort(value) || 0}
                    </Tooltip>
                  </Typography>
                </Box>
              );
            })}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
